import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/worksheets")({
  staticData: {
    breadcrumb: "Worksheets",
  },
  component: () => <Outlet />,
});
